import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { saveAs } from "file-saver";
import { Button, Dropdown, message } from "antd";
import { ExportOutlined } from "@ant-design/icons";

const ExportTableData = ({
    columns = [],
    dataSource = [],
    fileName = "report",
    pdfTitle = "",
    sheetName = "Sheet",
    fontSize = 10,
    titleFontSize = 14,
    pdfLayout = "portrait",
}) => {
    const getSafeSheetName = (name) => {
        const trimmed = name.trim().substring(0, 31);
        const invalidCharsRegex = /[:\\/?*\[\]]/g;
        return trimmed.replace(invalidCharsRegex, "");
    };

    const getValueByPath = (obj, path) => {
        if (Array.isArray(path)) {
            return path.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
        }
        return obj?.[path];
    };

    const exportToPDF = () => {
        const doc = new jsPDF({ orientation: pdfLayout }); // <-- layout applied here
        const tableColumn = columns.map((col) => col.title);
        const tableRows = dataSource.map((row) =>
            columns.map((col) => {
                const value = getValueByPath(row, col.dataIndex);
                return typeof col.render === "function" ? col.render(value, row) : value ?? "N/A";
            })
        );

        if (pdfTitle) {
            doc.setFontSize(titleFontSize);
            doc.text(pdfTitle, 14, 20);
        }

        autoTable(doc, {
            startY: pdfTitle ? 30 : 10,
            head: [tableColumn],
            body: tableRows,
            styles: { fontSize: fontSize },
        });

        doc.save(`${fileName}.pdf`);
    };

    const exportToExcel = () => {
        const worksheetData = dataSource.map((row) => {
            const obj = {};
            columns.forEach((col) => {
                const value = getValueByPath(row, col.dataIndex);
                obj[col.title] = typeof col.render === "function" ? col.render(value, row) : value ?? "N/A";
            });
            return obj;
        });

        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        const safeSheetName = getSafeSheetName(sheetName || "Sheet");

        if (sheetName.length > 31) {
            message.warning("Sheet name exceeded 31 characters. It has been trimmed.");
        }

        XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName);
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, `${fileName}.xlsx`);
    };

    const exportMenu = {
        items: [
            {
                key: "pdf",
                label: "Export to PDF",
                onClick: exportToPDF,
            },
            {
                key: "excel",
                label: "Export to Excel",
                onClick: exportToExcel,
            },
        ],
    };

    return (
        <Dropdown menu={exportMenu} placement="bottomRight">
            <Button size="small" icon={<ExportOutlined />}>Export</Button>
        </Dropdown>
    );
};

export default ExportTableData;
